import React from 'react';
import PropTypes from 'prop-types';
import HeroAutocomplete from '../../../../../components/HeroAutocomplete/HeroAutocomplete';
import css from './HeroSearchSection.module.css';

const HeroSearchSection = ({
  onSearch = null,
  onEventSelect = null,
  onAttractionSelect = null,
}) => {
  return (
    <div className={css.heroSection}>
      <HeroAutocomplete
        onSearch={onSearch}
        onEventSelect={onEventSelect}
        onAttractionSelect={onAttractionSelect}
        className={css.heroSearch}
      />
    </div>
  );
};

HeroSearchSection.propTypes = {
  onSearch: PropTypes.func,
  onEventSelect: PropTypes.func,
  onAttractionSelect: PropTypes.func,
};

export default HeroSearchSection;
